import { useCallback, useRef, useState } from 'preact/hooks';
import useAppDispatch from '../../../hooks/useAppDispatch';
import './SearchByTextHomeItemFeature.less';
import IconButton from '../../button/IconButton';
import { useEffect } from 'preact/hooks';
import { useTranslation } from '../../../hooks/useTranslation';

const SearchByTextHomeItemFeature = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [searchText, setSearchText] = useState('');
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    const onKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                dispatch.featureState
                    .startFeature({
                        featureType: 'product-search-by-text',
                        searchText
                    })
                    .catch(() => {});
                event.preventDefault();
            }
        },
        [searchText]
    );

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [textareaRef.current]);

    return (
        <div className={`bri-SearchByTextHomeItemFeature`}>
            <textarea
                ref={textareaRef}
                placeholder={t('PRODUCT_SEARCH_BY_TEXT_INPUT_PLACEHOLDER')}
                value={searchText}
                onChange={e => setSearchText(e.currentTarget.value)}
                onKeyDown={onKeyDown}
                className={'bri-SlimScroll'}
            />
            <IconButton
                variant="primary"
                disabled={!searchText}
                iconId="send"
                onClick={() =>
                    dispatch.featureState.startFeature({
                        featureType: 'product-search-by-text',
                        searchText
                    })
                }
            />
        </div>
    );
};

export default SearchByTextHomeItemFeature;
